<template>
    <div class="cairline-left">
        <topTabs :tabsObj="tabsObj" @tabSwitch="handleHeaderTabChange"></topTabs>
        <div class="cairline-left__main">
            <template v-if="showAdd && type != 3">
                <div class="cairline-left__btn flex-align-center">
                    <el-button v-has="'fcs:route:add'" class="btn-add" type="primary" @click.stop="addRoute">{{
                        $t('route.left.createRoute') }}</el-button>
                    <el-button v-has="'fcs:route:add'" class="btn-add" type="primary" @click.stop="handleImportClick">{{
                        $t('route.airline.importRoute') }}</el-button>

                </div>

                <div class="cairline-left__content">
                    <div class="cairline-left__cell">
                        <div class="cell-name">{{ $t('route.left.routeName') }}</div>
                        <div class="cairline-left__desc">

                            <el-input :placeholder="$t('route.left.enterRouteName')" clearable
                                v-model.trim="searchForm.name" class="route-name" @input="debounceSearchInput">
                                <i slot="prefix" class="el-input__icon el-icon-search input-search"></i>
                            </el-input>
                        </div>
                    </div>
                    <div class="cairline-left__cell" v-show="type !== 2">
                        <div class="cell-name">{{ $t('route.left.site') }}</div>
                        <div class="cairline-left__desc">
                            <el-select class="cell-hangar" popper-class="select-mask" v-model="searchForm.siteId"
                                :placeholder="$t('route.left.selectSite')" filterable clearable @change="doSearch">
                                <el-option v-for="item in hiveOptionList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div v-show="type !== 2" class="cairline-left__cell flex-align-center " style="padding:6px 0px">
                        <div class="cell-name" style="flex-shrink: 0;padding:0px">{{ $t('route.left.type') }}</div>
                        <div class="cairline-left__desc">
                            <el-tooltip class="item" effect="dark" content="" placement="top"
                                popper-class="icon-tooltip" v-for="item in searchTypeOptions" :key="'st_' + item.value">
                                <div slot="content">{{ item.label }}</div>
                                <img style="width: 22px; height: 22px; margin: 0 8px;cursor: pointer;"
                                    @click="handleSearchTypeChange(item)"
                                    :src="searchForm.type == item.value ? item.selectedIcon : item.icon" fit="fit" />
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="cairline-left__cell wayline-block" :style="waylineBlockStyle">
                        <div class="cell-name">{{ $t('route.left.routeList') }}</div>
                        <div class="cairline-left__desc wayline-block__content">
                            <div class="route-list">
                                <template v-if="routeList && routeList.length > 0">
                                    <YScroll style="height: 100%">
                                        <div class="route-cell" :class="item.id === currentRouteId
                                            ? 'activity-col'
                                            : 'default-col'
                                            " v-for="(item, index) in routeList" :key="item.id"
                                            @click.stop="handleRouteListItemClick(item, index)">
                                            <el-tooltip popper-class="cell-tooltip" effect="dark"
                                                placement="right-start">
                                                <template v-slot:content>
                                                    <div class="tooltip-content">
                                                        <div class="tooltip-info">
                                                            {{ item.name }}
                                                        </div>
                                                        <div class="tooltip-info">
                                                            {{ $t('route.left.routeType') }}： {{ getType(item.type)
                                                            }}
                                                        </div>
                                                        <div class="tooltip-info display-flex">
                                                            <div class="lable">{{ $t('route.left.status') }}</div>
                                                            <div class="value" :class="item.status == 0 ? 'col-start' : 'col-stop'
                                                                ">
                                                                {{ item.status == 0 ? $t('route.left.enable')
                                                                    : $t('route.left.disable') }}

                                                            </div>
                                                        </div>
                                                        <div class="tooltip-info">
                                                            {{ $t('route.left.routeLength') }}（km）：{{ item.distance
                                                                || 0 }}
                                                        </div>
                                                        <div class="tooltip-info">
                                                            {{ $t('route.left.waypoints') }}{{ item.counts || 0 }}
                                                        </div>
                                                        <div class="tooltip-info">
                                                            {{ $t('route.left.estimatedTime') }}（min）：{{
                                                                item.estimateTime
                                                                || 0 }}
                                                        </div>
                                                        <div class="tooltip-info display-flex">
                                                            <div class="lable">{{ $t('route.left.updateTime') }}
                                                            </div>
                                                            <div class="value">
                                                                {{ item.updateTime }}
                                                            </div>
                                                        </div>
                                                        <div class="tooltip-info display-flex">
                                                            <div class="lable">{{ $t('route.left.remark') }}</div>
                                                            <el-tooltip class="item" effect="dark"
                                                                :content="item.remark" placement="top"
                                                                popper-class="txt-tooltip">
                                                                <div class="value" style="">
                                                                    {{ item.remark }}
                                                                </div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>
                                                </template>
                                                <div class="cell-main">
                                                    <div class="cell-info display-flex">
                                                        <!-- <div class="lable">{{ $t('route.left.name') }}：</div> -->
                                                        <div class="value">
                                                            <el-tooltip class="value-tips" popper-class="txt-tooltip"
                                                                effect="dark" :content="item.name"
                                                                placement="top-start">
                                                                <div class="overflow">{{ item.name }}</div>
                                                            </el-tooltip>
                                                        </div>
                                                    </div>

                                                    <div class="cell-info display-flex flex-start cell-btn"
                                                        v-if="item.type !== 'MappingGrid'">
                                                        <div v-has="'fcs:route:edit'" class="display-flex">
                                                            <el-tooltip class="item" effect="dark"
                                                                :content="$t('route.left.edit')" placement="top"
                                                                popper-class="icon-tooltip">
                                                                <div class="cell-img img-edit"
                                                                    @click.stop="handleEditClick(item, index)"></div>
                                                            </el-tooltip>
                                                            <div class="cell-bor-1"></div>
                                                        </div>

                                                        <div v-has="'fcs:route:add'" class="display-flex">
                                                            <el-tooltip class="item" effect="dark"
                                                                :content="$t('route.left.copy')" placement="top"
                                                                popper-class="icon-tooltip">
                                                                <div class="cell-img img-copy"
                                                                    @click.stop="handleRouteCopy(item, index)"></div>
                                                            </el-tooltip>
                                                            <div class="cell-bor-1"></div>
                                                        </div>

                                                        <div v-has="'fcs:route:remove'" class="display-flex">
                                                            <el-tooltip class="item" effect="dark"
                                                                :content="$t('route.left.delete')" placement="top"
                                                                popper-class="icon-tooltip">
                                                                <div class="cell-img img-del"
                                                                    @click.stop="handleRouteDeleteClick(item, index)">
                                                                </div>
                                                            </el-tooltip>
                                                            <div class="cell-bor-1"></div>
                                                        </div>
                                                        <div v-has="'fcs:route:edit'" class="display-flex">
                                                            <el-tooltip class="item" effect="dark"
                                                                :content="item.status == 1 ? $t('route.left.enable') : $t('route.left.disable')"
                                                                placement="top" popper-class="icon-tooltip">
                                                                <div class="cell-img" :class="item.status == 0 ? 'img-stop' : 'img-start'
                                                                    "
                                                                    @click.stop="handleChangeStatusClick(item, index)">
                                                                </div>
                                                            </el-tooltip>
                                                            <div class="cell-bor-1"></div>
                                                        </div>
                                                        <el-tooltip v-has="'fcs:route:export'" class="item"
                                                            effect="dark" :content="$t('route.airline.exportRoute')"
                                                            placement="top" popper-class="icon-tooltip">
                                                            <el-dropdown placement="bottom"
                                                                @command="handleExportClick(item, index, $event)">
                                                                <div class="cell-img ">
                                                                    <i class="el-icon-download img-export"
                                                                        style="font-size: 20px;cursor:pointer"></i>
                                                                </div>
                                                                <el-dropdown-menu slot="dropdown">
                                                                    <el-dropdown-item command="kml">{{
                                                                        $t('route.airline.downloadKml')
                                                                        }}</el-dropdown-item>
                                                                    <el-dropdown-item command="kmz">{{
                                                                        $t('route.airline.downloadKmz')
                                                                        }}</el-dropdown-item>
                                                                </el-dropdown-menu>
                                                            </el-dropdown>
                                                        </el-tooltip>
                                                    </div>
                                                </div>
                                            </el-tooltip>
                                        </div>
                                    </YScroll>
                                </template>
                                <template v-else>
                                    <div class="null-desc">
                                        <img class="img-null-route" src="../imgs/null-route.png" />
                                        <div class="null-txt">{{ $t('route.left.noRoute') }}</div>
                                    </div>
                                </template>
                            </div>
                            <div class="txt-pagination">
                                <el-pagination class="pagination-min" small background align="center"
                                    layout="prev, pager, next" :total="pageConfig.total"
                                    :current-page.sync="pageConfig.pageNum" @current-change="currentChange">
                                </el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <CustomElScrollbar class="grid-scrollbar">
                    <div v-for="item in gridGroupList" :key="item.id" class="list-item pointer"
                        @click="handleGridGroupClick(item)">
                        <custom-marquee :textLength="item.name ? item.name.length : 0"> {{ item.name }}</custom-marquee>
                    </div>
                    <CustomEmpty v-if="gridGroupList.length <= 0"></CustomEmpty>
                </CustomElScrollbar>
            </template>
        </div>
        <!-- 弹窗 -->
        <el-dialog :visible.sync="dialogVisible" :append-to-body="true" width="680px" center :show-close="false"
            class="dialog-main">
            <div slot="title" class="dialog-title">
                {{ isImport ? $t('route.airline.importRoute') : $t('route.left.createRoute') }}
                <img class="icon-close" :src="imgs.icon_close" @click="closeDialog" />
            </div>
            <el-form :model="routeForm" :rules="rules" ref="routeForm">
                <template>
                    <el-form-item :label="$t('route.left.routeName')" label-width="110px" prop="name" class="form-item">
                        <el-input v-model.trim="routeForm.name" autocomplete="off"
                            :placeholder="$t('route.left.enterRouteName')"></el-input>
                    </el-form-item>
                    <el-form-item :label="$t('route.left.site')" label-width="110px" prop="siteId" class="form-item"
                        v-if="type !== 2">
                        <el-select class="cell-hangar" v-model="routeForm.siteId"
                            :placeholder="$t('route.left.selectSite')" popper-class="select-mask">
                            <el-option v-for="item in hiveOptionList" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item v-if="!isImport" :label="$t('route.left.routeType')" label-width="110px" prop="type"
                        class="form-item">
                        <div class="display-flex space-between">
                            <div v-for="(item) in routeTypeOptions" :key="'rt_' + item.value" class="route-cell"
                                :class="routeForm.type == item.value ? 'route-activity' : 'route-default'"
                                @click="handleSelectTouteType(item)">
                                <img class="route-img" :src="routeForm.type == item.value
                                    ? item.selectedIcon
                                    : item.icon
                                    " />
                                <div>{{ item.label }}</div>
                            </div>

                        </div>
                    </el-form-item>
                </template>
                <template v-if="isImport">
                    <el-form-item prop="fileList" label=" " label-width="110px">
                        <el-upload ref="uploadRef" class="c-upload" :show-file-list="true"
                            :action="`${baseURL}/fcs/route/uploadKmz`" :headers="uploadHeaders" :autoUpload="false"
                            :limit="1" accept=".kml,.kmz" :data="uploadForm" :on-exceed="handleExceed"
                            :before-upload="beforeUpload" :on-change="onUploadChange" :on-remove="onUploadRemove"
                            :on-success="onUploadSuccess">
                            <el-button slot="trigger" size="small" type="primary"
                                icon="el-icon-upload">导入kmz文件</el-button>

                            <div class="el-upload__tip" slot="tip">
                                只能上传kmz文件,kmz 中需包含 wpmz/template.kml 及
                                wpmz/waylines.wpml 文件。
                            </div>
                            <!-- 自定义 file 渲染 -->
                            <template slot="file" slot-scope="{file}">
                                <div class="custom-upload-file-item flex-center">
                                    <span style="flex:1" class="file-name">{{ file.name }}</span>
                                    <span style="flex-shrink: 0;" class="file-status">
                                        <el-tag :type="parseFileStatusType(file.status)">{{ parseFileStatus(file.status)
                                            }}</el-tag>
                                    </span>
                                    <span style="flex-shrink: 0;" class="delete-icon">
                                        <i class="el-icon-delete" @click="removeFile(file)"></i>
                                    </span>
                                </div>

                                <el-progress v-if="file.status === 'uploading'" :stroke-width="6"
                                    :percentage="parsePercentage(file.percentage)" text-color="#ffffff">
                                </el-progress>



                            </template>
                        </el-upload>

                    </el-form-item>
                </template>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button class="route-btn btn-close" @click="closeDialog">{{ $t('route.left.cancelBlank')
                }}</el-button>
                <el-button :loading="uploadBtnLoading" class="route-btn btn-define" type="primary"
                    @click="handleSaveClick">{{
                        isImport ? $t('common.btnImport') : $t('route.left.createRoute')
                    }}</el-button>
            </div>
        </el-dialog>

    </div>
</template>

<script>
// import { log } from 'console';
import { YScroll } from '@CommonComponent';
import moment from 'moment';
import topTabs from '@/components/topTabs.vue';
import imgs from '../imgs';
import GridApi from '@/api/grid';
import { WaylineTemplateType } from '../constant/constant';
import Api from '../main/api.js';
import { debounce } from '@/utils/common.js';
// import KmzSdk from '../util/KmzSdk/KmzSdk';
const createFormData = () => ({
    name: '',
    siteId: '',
    type: 'LineString',
    gridId: '',
    fileList: [],
});
export default {
    components: {
        YScroll,
        topTabs,
    },
    props: {
        routeId: String,
        gridId: String,
        showAdd: {
            // 是否显示创建航线按钮
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            tabsObj: {
                left: this.$t('route.left.airport'),
                right: this.$t('route.left.manual'),
                type: 1,
                centre: this.$t('route.left.grid'),
            },
            type: 1,
            searchForm: {
                name: '',
                siteId: '',
                flyMode: 1,
                type: '',
            },
            currentRouteId: '', // 当前选中航线id
            routeList: [],
            pageConfig: {
                pageNum: 1,
                pageSize: 10,
                total: 0,
            },
            hiveOptionList: [],
            imgs,
            dialogVisible: false,
            isImport: false, // 标识弹框是否是导入航线
            // fileList: [],
            baseURL: window.gconfig ? window.gconfig.VITE_APP_BASE_API || '/api' : '/api',
            uploadHeaders: {
                Authorization: `Bearer ${localStorage.getItem('Admin-Token')}`,
                clientid: `${window.gconfig.VITE_APP_CLIENT_ID}`,
            },
            uploadBtnLoading: false,
            routeForm: createFormData(),
            uploadForm: {
                routeName: "",
                siteId: "",

            },
            rules: {
                name: [{ required: true, message: this.$t('route.left.enterRouteName'), trigger: 'blur' }],
                siteId: [{ required: true, message: this.$t('route.left.selectSite'), trigger: 'change' }],
                type: [{ required: true, message: this.$t('route.left.selectRouteType'), trigger: 'change' }],
                gridId: [{ required: true, message: this.$t('route.left.selectGrid'), trigger: 'change' }],
                fileList: [{ required: true, type: 'array', message: this.$t('route.left.selectFile'), trigger: 'change' }],
            },

            gridPage: {
                page: 1,
                pageSize: 10,
                total: 0,
            },
            gridGroupList: [],
            debounceSearchInput: () => { }, // 搜索框输入变化防抖

        };
    },
    computed: {
        tabsObj() {
            let obj = {
                left: this.$t('route.left.airport'),
                right: this.$t('route.left.manual'),
                type: 1,
                centre: this.$t('route.left.grid')
            }
            if (typeof this.$checkPermission == 'function') {
                if (!this.$checkPermission('fcs:route:grid')) {
                    obj.centre = ''
                }
                if (!this.$checkPermission('fcs:route:manual')) {
                    obj.right = ''
                }
            }
            return obj
        },
        waylineBlockStyle() {
            const routNameH = 74;
            const siteSelectH = 74;
            // const typeSelectH = 68
            const typeSelectH = 42;
            let sumH = 0;
            if (this.type == 1) {
                sumH = routNameH + siteSelectH + typeSelectH;
            } else {
                sumH = routNameH;
            }
            return {
                height: `calc(100% - ${sumH}px)`,
            };
        },

        routeTypeOptions() {
            let list = [
                {
                    value: 'LineString',
                    label: this.$t('route.left.waypointMode'),
                    iconType: 'image', // image 图片 icon 图标
                    icon: imgs.icon_hangdian, // 默认图片路径、图标名称
                    selectedIcon: imgs.icon_hangdian_activity, // 选中图片路径、图标名称
                    hidden: false, // 是否隐藏该项
                },
                {
                    value: 'Polygon',
                    label: this.$t('route.left.polygonMode'),
                    iconType: 'image', // image 图片 icon 图标
                    icon: imgs.icon_duobianxing,
                    selectedIcon: imgs.icon_duobianxing_activity,
                    hidden: false,
                },
                {
                    // 还没实现，之前的版本的功能没什么用，暂时隐藏
                    value: 'Circle',
                    label: this.$t('route.left.circularMode'),
                    iconType: 'image', // image 图片 icon 图标
                    icon: imgs.icon_huanxing,
                    selectedIcon: imgs.icon_huanxing_activity,
                    hidden: true,
                },
                {

                    value: 'Tilt',
                    label: this.$t('route.left.obliqueRoute'),
                    icon: imgs.icon_qingxie,
                    iconType: 'image', // image 图片 icon 图标
                    selectedIcon: imgs.icon_qingxie_activity,
                    hidden: true,
                },
                {

                    value: 'Mapping',
                    label: this.$t('route.left.mappingSurvey'),
                    iconType: 'image', // image 图片 icon 图标
                    icon: imgs.Icon_orthophotomap,
                    selectedIcon: imgs.Icon_orthophotomap_activity,
                    hidden: true,
                },
                {

                    value: WaylineTemplateType.mapping2d, // 'maping2d'
                    label: this.$t('route.left.mappingSurvey'),
                    iconType: 'image', // image 图片 icon 图标
                    icon: imgs.Icon_orthophotomap,
                    selectedIcon: imgs.Icon_orthophotomap_activity,
                    hidden: false,
                },
                {
                    value: 'MappingGrid',
                    label: this.$t('route.left.gridMode'),
                    iconType: 'image', // image 图片 icon 图标
                    icon: imgs.icon_wangge,
                    selectedIcon: imgs.icon_wangge_activity,
                    hidden: true,
                },

            ];

            return list.filter((item) => !item.hidden);
        },
        searchTypeOptions() {
            let list = [
                {
                    value: '',
                    label: this.$t('route.left.all'),
                    iconType: 'image', // image 图片 icon 图标
                    icon: imgs.icon_min_all, // 默认图片路径、图标名称
                    selectedIcon: imgs.icon_min_all_activity, // 选中图片路径、图标名称
                    hidden: false, // 是否隐藏该项
                },

            ].concat(this.routeTypeOptions);

            return list.filter((item) => !item.hidden);
        },
    },

    methods: {
        /**
         * 处理头部标签切换事件
         *
         * @param {number} type - 标签类型
         */
        handleHeaderTabChange(type) {
            this.type = type;

            if (type != 3) {
                this.searchForm = {
                    name: '',
                    siteId: '',
                    flyMode: type === 2 ? 0 : 1,
                    type: '',

                };
                this.getRouteList(1);
            } else {
                this.getGridGroupList();
            }
            this.$emit('tabChange', type);
        },
        searchInputChange() {
            this.doSearch();
        },
        doSearch() {
            this.getRouteList(1);
        },
        /**
         * 处理搜索类型变化事件
         *
         * @param e 事件对象
         */
        handleSearchTypeChange(e) {
            let type = e.value;
            this.searchForm.type = type;
            this.doSearch();
        },
        currentChange(page) {
            this.getRouteList(page);
        },

        handleRouteListItemClick(item, index) {
            this.currentRouteId = item.id;
            this.$emit('routeItemClick', item, index);
        },
        /**
         * 处理编辑点击事件
         * @param data 包含id, gridId, gridGroupId, type等属性的对象
         * @param index 当前项的索引
         */
        handleEditClick(data, index) {
            const { id, gridId, gridGroupId, type } = data;
            if (id) {
                let query = {

                };
                if (gridId && gridGroupId) {
                    query.gridId = gridId;
                    query.gridGroupId = gridGroupId;
                }
                this.$router.push({
                    path: `/route/edit/${id}`,
                    query,
                });
            }
        },
        /**
         *复制航线
         * @param item 需要复制的航线对象
         */
        handleRouteCopy(item, index) {
            const self = this;
            this.$confirm(this.$t('route.left.willCopyRoute', [item.name]), this.$t('route.left.tips'), {
                confirmButtonText: this.$t('route.left.confirm'),
                cancelButtonText: this.$t('route.left.cancel'),
                type: 'warning',
            })
                .then(() => {
                    Api.getRouteCopy(item.id).then((res) => {
                        if (res.code == 200) {
                            this.$message({
                                type: 'success',
                                message: this.$t('common.copySuccess'),
                            });
                            self.getRouteList(1);
                            let data = res.data;
                            if (data) {
                                self.handleRouteListItemClick(data, 0);
                            }
                        } else {
                            this.$message({
                                type: 'error',
                                message: this.$t('common.copyFailed'),
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('route.left.operationCanceled'),
                    });
                });
        },
        /**
         * 处理航线删除点击事件
         * @param item 要删除的航线对象
         */
        handleRouteDeleteClick(item) {
            const self = this;
            this.$confirm(this.$t('route.left.willDeleteRoute', [item.name]), this.$t('route.left.tips'), {
                confirmButtonText: this.$t('route.left.confirm'),
                cancelButtonText: this.$t('route.left.cancel'),
                type: 'warning',
            })
                .then(() => {
                    const id = item.id;
                    Api.getRouteDelete(id).then((res) => {
                        if (res.code == 200) {
                            this.$message({
                                type: 'success',
                                message: this.$t('common.operationSuccess'),
                            });
                            self.getRouteList(1);
                            self.$emit('deleteSuccess', item);
                        } else {
                            this.$message({
                                type: 'error',
                                message: res.msg,
                            });
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('route.left.operationCanceled'),
                    });
                });
        },
        handleChangeStatusClick(item, index) {
            const id = item.id;
            this.$confirm(
                // `此操作将${item.status === 0 ? this.$t('route.left.disable') : this.$t('route.left.enable')}航线“${item.name}”, 是否继续?`,
                this.$t('route.left.willStatusRoute', [item.status === 0 ? this.$t('route.left.disable') : this.$t('route.left.enable'), [item.name]]),
                this.$t('route.left.tips'),
                {
                    confirmButtonText: this.$t('route.left.confirm'),
                    cancelButtonText: this.$t('route.left.cancel'),
                    type: 'warning',
                },
            )
                .then(() => {
                    const status = item.status;

                    if (status === 0) {
                        Api.setDisable(id).then((res) => {
                            if (res.code == 200) {
                                item.status = 1;
                                this.$message({
                                    type: 'success',
                                    message: this.$t('common.operationSuccess'),
                                });
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg,
                                });
                            }
                        });
                    } else {
                        Api.setEnable(id).then((res) => {
                            if (res.code == 200) {
                                item.status = 0;
                                this.$message({
                                    type: 'success',
                                    message: this.$t('common.operationSuccess'),
                                });
                            } else {
                                this.$message({
                                    type: 'error',
                                    message: res.msg,
                                });
                            }
                        });
                    }
                });
        },
        /**
         * 处理导出点击事件
         *
         * @param item 点击导出的项
         */
        handleExportClick(item, index, type) {
            console.log(type);
            const id = item.id;
            if (type === 'kml') {
                Api.setDownLoadKml(id).then((fileData) => {
                    if (!fileData) return;

                    // ✅ 正确的 KML MIME 类型
                    const blob = new Blob([fileData], {
                        type: 'application/vnd.google-earth.kml+xml',
                    });

                    const time = moment().format('YYYY_MM_DD HHmmss');
                    const fileName = `${item.name}_${time}.kml`;

                    // ✅ 兼容 IE11+
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = fileName;
                        document.body.appendChild(link); // ✅ 有些浏览器要求必须插入 DOM
                        link.click();
                        document.body.removeChild(link); // ✅ 移除 DOM 元素
                        // ✅ 异步释放对象 URL，确保浏览器不出错
                        setTimeout(() => {
                            window.URL.revokeObjectURL(url);
                        }, 100);
                    }
                });
            } else if (type == 'kmz') {
                Api.downLoadKmz(id).then((fileData) => {
                    if (!fileData) return;

                    // ✅ 正确的 KML MIME 类型
                    const blob = new Blob([fileData], {
                        type: 'application/vnd.google-earth.kmz',
                        // type: 'application/zip'
                    });

                    const time = moment().format('YYYY_MM_DD HHmmss');
                    const fileName = `${item.name}_${time}.kmz`;

                    // ✅ 兼容 IE11+
                    if (window.navigator.msSaveOrOpenBlob) {
                        window.navigator.msSaveBlob(blob, fileName);
                    } else {
                        const url = window.URL.createObjectURL(blob);
                        const link = document.createElement('a');
                        link.href = url;
                        link.download = fileName;
                        document.body.appendChild(link); // ✅ 有些浏览器要求必须插入 DOM
                        link.click();
                        document.body.removeChild(link); // ✅ 移除 DOM 元素
                        // ✅ 异步释放对象 URL，确保浏览器不出错
                        setTimeout(() => {
                            window.URL.revokeObjectURL(url);
                        }, 100);
                    }
                });
            }
        },

        addRoute() {
            this.isImport = false;
            if (this.FlyType === 'freedom') {
                if (this.SeeState) {
                    this.setRoute();
                } else {
                    this.setRoute();
                }
            } else {
                this.dialogVisible = true;

                // this.routeForm = {
                //     ...this.routeForm,
                //     name: '',
                //     siteId: '',
                //     type: 'LineString',

                //     // flyMode: '1',
                // };
                this.routeForm = createFormData();
            }
        },
        handleImportClick() {
            this.isImport = true;
            this.dialogVisible = true;
        },

        setRoute() {
            setTimeout(() => {
                // this.routeForm = {
                //     name: '',
                //     siteId: '',
                //     type: 'LineString',
                //     flyMode: '1',
                // };
                let newForm = createFormData();
                newForm.flyMode = "1"
                this.routeForm = newForm

                this.RouteAdd('LineString', this.routeForm);
            }, 500);
        },
        closeDialog() {
            this.dialogVisible = false;
        },

        /**
         * 选择航线类型
         * @param type 航线类型
         */
        handleSelectTouteType(data) {
            this.routeForm.type = data.value;
            if (data) {
                // 自动填充航线名称，如果用户手动修改了就不用自动填充了
                if (!this.routeForm.name) {
                    this.routeForm.name = data.label;
                } else {
                    let routeTypeOptions = this.routeTypeOptions;
                    let labelList = [];
                    routeTypeOptions.forEach((item) => {
                        labelList.push(item.label);
                    });
                    if (labelList.includes(this.routeForm.name)) {
                        this.routeForm.name = data.label;
                    }
                }
            }
        },

        /**
         * 处理弹框确按钮点击事件
         */
        handleSaveClick() {
            if (!this.isImport) {
                this.$refs.routeForm.validate((valid) => {
                    if (valid) {
                        this.closeDialog();
                        // 跳转到编辑界面
                        this.$router.push({
                            path: '/route/create',
                            query: {
                                type: this.routeForm.type,
                                name: this.routeForm.name,
                                siteId: this.routeForm.siteId,

                            },
                        });
                    }
                });
            } else if (this.$refs.uploadRef) {
                if (this.$refs.routeForm) {
                    this.$refs.routeForm.validate((valid) => {
                        if (valid) {
                            this.uploadForm.routeName = this.routeForm.name;
                            this.uploadForm.siteId = this.routeForm.siteId;
                            this.$refs.uploadRef.submit();
                        } else {
                            setTimeout(() => {
                                if (this.$refs.routeForm) {
                                    this.$refs.routeForm.clearValidate('fileList');
                                }
                            }, 1000 * 2);
                        }
                    });

                }

            }
        },
        getType(type) {
            switch (type) {
                case WaylineTemplateType.LineString:
                    return this.$t('route.left.waypointMode');
                case WaylineTemplateType.waypoint:
                    return this.$t('route.left.waypointMode');
                case WaylineTemplateType.polygon:
                    return this.$t('route.left.polygonMode');
                case 'Circle':
                    return this.$t('route.left.circularMode');
                case 'Tilt':
                    return this.$t('route.left.obliqueMode');
                case 'Mapping':
                    return this.$t('route.left.mappingSurvey');
                case WaylineTemplateType.mapping2d:
                    return this.$t('route.left.mappingSurvey');
                case 'MappingGrid':
                    return this.$t('route.left.gridMode');
                default:
                    return this.$t('route.left.waypointMode');
            }
        },

        handleGridGroupClick(item) {
            const self = this;
            if (item.gridList) {
                this.$emit('gridGroupClick', item);
            } else {
                this.getGridGroupListUnits(item.id).then((res) => {
                    item.gridList = res.gridInfoList || [];
                    item.flightRouteList = res.flightRouteList || [];
                    self.$emit('gridGroupClick', item);
                });
            }
        },

        getGridGroupList(page) {
            if (page) {
                this.gridPage.page = page;
            }
            let params = {
                pageNum: this.gridPage.page,
                pageSize: this.gridPage.pageSize,
            };
            GridApi.fetchGridGroupList(params).then((res) => {
                if (res.code == 200) {
                    this.gridGroupList = res.rows || [];
                }
            });
        },
        getGridGroupListUnits(gridGroupId) {
            return new Promise((resolve) => {
                GridApi.fetchGridGroupUnits(gridGroupId).then((res) => {
                    let resData = {};
                    if (res.code == 200) {
                        resData = res.data || {};
                    }

                    resolve(resData);
                });
            });
        },
        getRouteList(page) {
            let currentPage = page || 1;
            let param = {
                ...this.searchForm,
                pageNum: currentPage,
                pageSize: this.pageConfig.pageSize,
            };
            Api.getRouteList(param).then((res) => {
                console.log(res);
                if (res.code == 200) {
                    this.routeList = res.rows || [];
                    this.pageConfig.total = res.total;
                    if (this.importRouteId) {
                        for (let i = 0; i < this.routeList.length; i++) {
                            const item = this.routeList[i]
                            if (item.id == this.importRouteId) {
                                this.importRouteId = "" // 重置
                                this.handleRouteListItemClick(item, i) // 拿到 index 和目标项
                                break // 找到就退出循环
                            }
                        }
                    }
                }
            });
        },
        async getDockOptionList() {
            let res = await Api.getDockOptionList();
            this.hiveOptionList = res.data;
        },
        handleExceed(files, fileList) {
            // 超出时，替换掉旧文件
            const upload = this.$refs.uploadRef;
            const newFile = files[files.length - 1];

            // 1. 清除旧文件
            upload.clearFiles();

            // 2. 添加新文件（模拟文件选择）
            upload.handleStart(newFile);

            // 3. 等待 DOM 更新后自动上传（确保文件加入队列）
            // this.$nextTick(() => {
            //     upload.submit();
            // });
        },
        beforeUpload(file) {
            const isKmlOrKmz = /\.(kml|kmz)$/i.test(file.name);
            if (!isKmlOrKmz) {
                this.$message.error('只能上传 .kml 或 .kmz 文件');
                return false; // 阻止上传
            }
            this.uploadBtnLoading = true;
            return true;
        },
        onUploadChange(file, fileList) {
            this.routeForm.fileList = fileList
        },
        onUploadRemove(file, fileList) {
            this.routeForm.fileList = fileList
        },
        /**
        * 上传成功后的回调函数
        *
        * @param response 服务器返回的响应数据
        * @param file 上传的文件对象
        */
        onUploadSuccess(response, file) {

            if (response.code == 200) {
                this.$message({
                    type: 'success',
                    message: this.$t('common.importSuccess'),
                });
                this.getRouteList(1);
                this.closeDialog();
                if (response.data) {
                    this.importRouteId = response.data;
                }
            } else {
                file.status = 'fail'
                this.importRouteId = ""
                this.$message({
                    showClose: true,
                    message: response.msg || this.$t('common.importFailed'),
                    type: 'error',
                    onClose: () => {
                        file.status = 'ready'
                    },
                });
            }
            this.uploadBtnLoading = false;
        },
        /**
        * 初始化KMZ文件处理的工作线程
        */
        async initKmzWorker() {
            // const { default: KmzWorker } = await import(
            //     /* webpackChunkName: "kmz-worker" */
            //     /* webpackInclude: /\.worker\.js$/ */
            //     `@/page/routePage/worker/kmz.worker.js`
            // );
            // if (!this.kmzWorker) {
            //     this.kmzWorker = new KmzWorker(`?v=${Date.now()}`);
            //     this.kmzWorker.onmessage = (e) => {
            //         console.log('KMZ文件处理完成', e.data);
            //     };
            // }
        },
        parseFileStatusType(status) {
            switch (status) {
                case 'ready':
                    return 'info';
                case 'uploading':
                    return '';
                case 'success':
                    return 'success';
                case 'fail':
                    return 'danger';

                default:
                    return '';
            }
        },
        parseFileStatus(status) {
            switch (status) {
                case 'ready':
                    return "待上传";
                case 'uploading':
                    return "上传中";
                case 'success':
                    return "已完成";
                case 'fail':
                    return "上传失败";

                default:
                    return "";
            }
        },
        parsePercentage(val) {
            return parseInt(val, 10);
        },
        removeFile(file) {
            // 先从内部队列移除
            if (this.$refs.uploadRef) {
                this.$refs.uploadRef.handleRemove(file)
            }
            this.routeForm.fileList = this.routeForm.fileList.filter(f => f.uid !== file.uid)

        }
    },
    watch: {
        dialogVisible(val) {
            if (!val) {
                this.routeForm.fileList = [];
                this.$nextTick(() => {
                    if (this.$refs.uploadRef) {
                        this.$refs.uploadRef.clearFiles();
                    }
                    if (this.$refs.routeForm) {
                        this.$refs.routeForm.resetFields();
                    }
                });


            }
        },
    },
    created() {
        this.debounceSearchInput = debounce(this.searchInputChange, 500);
    },
    mounted() {
        this.getRouteList();
        this.getDockOptionList();
        // this.initKmzWorker();
    },
    beforeMount() {
        // if (this.kmzWorker) {
        //     this.kmzWorker.terminate();
        // }
    },
};
</script>

<style lang="scss" scoped>
@import '~@Theme/config.scss';
@import '~@Theme/mixins/index.scss';
$tabHeight: 65px;
$addBtnHeight: 37px;
$pageHeight: 46px;

.bor-top {
    border-top: 1px #6295ff solid;
}

@include b(left, cairline) {
    position: relative;
    width: 320px;
    height: calc(100% - 2px);
    min-height: 300px;
    color: white;
    background-color: #071150;
    overflow: hidden;

    // background-color: #03053f;// rgba(0, 0, 0, 0.5);
    @include e(main) {

        height: calc(100% - #{$tabHeight});
        padding: 0 16px;
        overflow: hidden;

        @include e(btn) {
            .btn-add {

                height: $addBtnHeight;
                // margin-top: 10px;
                background-image: linear-gradient(#1dc9ff, #49f0fd);
                border: 0;
                color: #000000;
                font-size: 16px;
                width: 100%
            }
        }

        @include e(content) {
            position: relative;
            height: calc(100% - #{$addBtnHeight});

            @include e(cell) {

                // padding-bottom: 10px;
                .cell-name {
                    padding: 14px 0;
                    font-weight: bold;
                }

                @include e(desc) {
                    text-align: left;

                    .route-name {
                        width: 256px;

                        ::v-deep.el-input__prefix {
                            // right: 0 !important;
                            left: 256px;
                            // border: 1px red solid;
                        }

                        ::v-deep.el-input__inner {
                            padding-left: 15px !important;
                            border-radius: 4px 0 0 4px;
                        }
                    }

                    .route-list {

                        // overflow: hidden;
                        .route-cell {
                            padding: 8px 8px 0 8px;
                            margin-bottom: 10px;
                            font-size: 14px;
                            border-radius: 2px;
                            border: solid #1e76ed;
                            border-width: 1px 1px 1px 3px;

                            // font-weight: initial;
                            .cell-btn {
                                // padding-top: 8px;
                            }

                            .cell-info {
                                padding-bottom: 8px;
                                // height: 16px;
                                line-height: 16px;

                                .lable {
                                    flex: 1;
                                }

                                .value {
                                    flex: 2.5;

                                    .value-tips {
                                        max-width: 195px;
                                        overflow: hidden;
                                        white-space: nowrap;
                                        text-overflow: ellipsis;
                                        -o-text-overflow: ellipsis;
                                    }
                                }

                                .cell-img {
                                    // margin-right: 15px;
                                    height: 20px;
                                    width: 20px;
                                }

                                .cell-bor-1 {
                                    width: 1px;
                                    height: 14px;
                                    margin: 3px 8px;
                                    border-right: 1px rgba(255, 255, 255, 0.3) solid;
                                }

                                .img-edit {
                                    background-image: url('../imgs/edit-box-line.png');
                                    background-repeat: no-repeat;

                                    &:hover {
                                        background-image: url('../imgs/edit-box-line-activity.png');
                                        background-repeat: no-repeat;
                                    }
                                }

                                .img-copy {
                                    background-image: url('../imgs/icon-copy.png');
                                    background-repeat: no-repeat;

                                    &:hover {
                                        background-image: url('../imgs/icon-copy-activity.png');
                                        background-repeat: no-repeat;
                                    }
                                }

                                .img-del {
                                    background-image: url('../imgs/delete-bin-line.png');
                                    background-repeat: no-repeat;

                                    &:hover {
                                        background-image: url('../imgs/delete-bin-line-activity.png');
                                        background-repeat: no-repeat;
                                    }
                                }

                                .img-stop {
                                    background-image: url('../imgs/icon-stop.png');
                                    background-repeat: no-repeat;
                                    background-size: 20px 20px;
                                    // &:hover {
                                    //     background-image: url('../imgs/icon-start.png');
                                    //     background-repeat: no-repeat;
                                    // }
                                }

                                .img-start {
                                    background-image: url('../imgs/icon-start.png');
                                    background-repeat: no-repeat;
                                    background-size: 20px 20px;
                                    // &:hover {
                                    //     background-image: url('../imgs/icon-stop.png');
                                    //     background-repeat: no-repeat;
                                    // }
                                }
                            }

                            .img-export {
                                color: rgba(255, 255, 255, 0.85);

                                &:hover {
                                    color: rgba(255, 255, 255, 1)
                                }
                            }
                        }
                    }

                    .null-desc {
                        text-align: center;

                        .img-null-route {
                            width: 152px;
                            height: 106px;
                            margin: 40px 0;
                        }

                        .null-txt {
                            height: 20px;
                            width: 100%;
                            font-size: 14px;
                            color: rgba(255, 255, 255, 0.66);
                        }
                    }

                    .txt-pagination {

                        padding: 10px 8px 10px 0;
                        overflow: hidden;
                        background: linear-gradient(180deg, rgba(7, 17, 80, 0.2) 0%, #071150 100%);
                        // border: 1px red solid;
                    }
                }

                .cairline-left-route {
                    // position: absolute;
                    // border:  1px red solid;
                    // width: 290px;
                    // left: 24px;
                    // right: 24px;
                    // bottom: 16px;
                }
            }

            .wayline-block {
                position: relative;

                &__content {
                    height: calc(100% - 42px);

                    .route-list {
                        height: calc(100% - #{$pageHeight});
                        overflow: hidden;
                    }
                }
            }

        }

        .list-item {
            padding: 8px;
            margin-bottom: 10px;
            font-size: 14px;
            border-radius: 2px;
            border: solid #1e76ed;
            border-width: 1px 1px 1px 3px;

            &.is-active,
            &:hover {
                background: rgba(30, 118, 237, 0.7);
            }
        }

        .grid-scrollbar {
            height: 100%;
            overflow: hidden;
        }
    }
}

.tooltip-content {
    min-width: 190px;
    min-height: 130px;

    .tooltip-remarks {
        border-bottom: 1px #666666 solid;
    }

    .tooltip-info {
        padding: 4px 0;
        font-size: 14px;

        .tooltip-title {
            font-size: 16px;
            font-weight: bold;
            padding-top: 10px;
        }

        .value {
            max-width: 130px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
        }
    }
}

.dialog-main {
    padding-top: 20vh;

    ::v-deep.el-dialog {
        background-color: #071150;
        color: white;
        box-shadow: inset 0px 0px 10px 0px #49f0fd;
        opacity: 1;
        border: 1px solid #49f0fd;
        border-radius: 4px;
    }

    ::v-deep.el-dialog__header {
        padding: 16px;
        border-bottom: #49f0fd 1px solid;
        box-shadow: inset 0px -1px 5px #49f0fd;
    }

    .dialog-title {
        text-align: left;
        position: relative;
        width: 100%;
        height: 20px;
        line-height: 20px;

        .icon-close {
            position: absolute;
            right: -38px;
            top: -37px;
            width: 41px;
            height: 41px;
        }
    }

    ::v-deep .c-upload {


        .el-upload-dragger {
            background-color: transparent !important;

            .el-upload__text {
                color: white;
            }
        }

        .el-upload__tip {
            color: rgba(255, 255, 255, 0.65) !important;
            line-height: 1.3;
        }

        .el-upload-list__item {
            $bgColor: #0A1D5B;
            background-color: $bgColor !important;
            color: #ffffff;
            padding: 10px;

            &:hover {
                background-color: $bgColor !important;
            }

            .file-status {
                margin-right: 20px;
            }

            .delete-icon {
                cursor: pointer;
                color: rgba(255, 255, 255, 0.65);
            }

            .el-progress {
                position: relative;
                top: 0px;
                margin-top: 6px;

                &-bar {
                    padding-right: 50px;
                    margin-right: -55px;
                }

                &__text {
                    position: relative;
                    top: 0px;


                }
            }

        }


    }

    ::v-deep .file-list-table {
        $tbBgColor: #01134A;
        background-color: $tbBgColor;
        color: #ffffff;

        &::before {
            background-color: #1b46d5;
        }

        tr {
            background-color: $tbBgColor;
        }

        &__header-cell {
            background-color: #0A1D5B;
            color: #ffffff;
            border-bottom-color: #1b46d5 !important;
        }

        &.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
            background-color: $tbBgColor !important;
        }
    }



    .form-item {
        margin-bottom: 30px;

        ::v-deep.el-form-item__label {
            color: white;
        }

        .cell-hangar {
            width: 100%;
        }

        .route-cell {
            text-align: center;
            width: 115px;
            height: 96px;
            line-height: 25px;
            border-radius: 2px 2px 2px 2px;
        }

        .route-img {
            width: 40px;
            height: 40px;
            margin-top: 10px;
        }

        .route-default {
            border-radius: 2px 2px 2px 2px;
            background: #071150;
            border: 1px solid rgba(46, 125, 248, 0.4);
            color: white;
        }

        .route-activity {
            box-shadow: inset 0px 0px 10px 0px #49f0fd;
            border-radius: 0px 0px 0px 0px;
            border: 1px solid #49f0fd;
            color: #49f0fd;
        }
    }

    .route-btn {
        width: 144px;
        font-size: 14px;
    }

    .btn-close {
        color: #49f0fd;
        border: 1px solid #49f0fd;
        background: rgba(73, 240, 253, 0.2);
    }

    .btn-define {
        color: #000000;
        background: #49f0fd;
        border: 1px solid #49f0fd;
    }

    .mar-bottom-0 {
        margin-bottom: 0px;
    }
}

.cell-hangar {
    width: 288px;
    text-align: left;
}

.display-flex {
    display: flex;
    align-items: center;
}

.flex-start {
    justify-content: flex-start;
}

.space-between {
    justify-content: space-between;
}

.col-start {
    color: #49f0fd;
}

.col-stop {
    color: #db4437;
}

.bor-bottom-1 {
    border-bottom: 1px #6295ff solid;
}

.activity-col {
    background: rgba(30, 118, 237, 0.7);

    &:hover {
        background: rgba(30, 118, 237, 0.7);
    }
}

.default-col {
    // background-color: #112d7b;
    background: linear-gradient(90deg,
            rgba(30, 118, 237, 0.5) 0%,
            rgba(30, 118, 237, 0.17) 34%,
            rgba(30, 118, 237, 0.17) 63%,
            rgba(30, 118, 237, 0.5) 100%);

    &:hover {
        background: rgba(30, 118, 237, 0.7);
    }
}

.width-288 {
    width: 288px;
}
</style>
<style lang="scss" scoped>
::v-deep.cairline-left__desc .el-input__inner,
::v-deep.form-item .el-input__inner {
    // width: 288px;
    background: #071150;
    border: 1px #1a47a4 solid;
    color: white;
}

::v-deep.cairline-left__desc .el-input__suffix {
    right: 1px;
    font-size: 18px;
}

::v-deep.cairline-left__desc .el-icon-search {
    color: white;
    border-radius: 0 4px 4px 0;
    width: 32px;
    height: 32px;
    // margin-top: 1px;
    font-size: 18px;
    line-height: 32px;
    background: #154fdb;
}

// ::v-deep.el-tooltip__popper {
//     background: none url(../imgs/icon-mask.png) no-repeat;
// }

::v-deep.pagination-min .el-pager li {
    margin: 0 5px;
    background-color: #112d7b !important;
    border-radius: 2px;
    color: #fff;
}

::v-deep.pagination-min .btn-next {
    /*对下一页的按钮样式进行修改*/
    background-color: #112d7b;
    color: #fff;
}

::v-deep.pagination-min .btn-prev {
    /*对上一页的按钮样式进行修改*/
    background-color: #112d7b;
    color: #fff;
}

::v-deep.pagination-min .el-pager li:not(.disabled).active {
    /*当前选中页数的样式进行修改*/
    background: rgba(73, 240, 253, 0.2);
    border-radius: 2px 2px 2px 2px;
    opacity: 1;
    border: 1px solid rgba(73, 240, 253, 0.4);
    line-height: 20px;
}
</style>

<style lang="scss">
.el-message-box {
    height: 170px;
    background: #071150;
    box-shadow: inset 0px 0px 10px 0px #49f0fd;
    border-radius: 6px 6px 0px 0px;
    opacity: 1;
    border: 1px solid #49f0fd;

    .el-message-box__title {
        color: #fff;

        .el-message-box__close {
            color: #fff !important;
        }
    }

    .el-message-box__content {
        display: flex;
        justify-content: center;
        color: #fff;
        font-size: 16px;
    }

    .el-message-box__headerbtn .el-message-box__close {
        color: #fff !important;
    }

    .el-message-box__btns {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 10px;

        button {
            width: 88px;
            height: 30px;
            background: #49f0fd;
            border-radius: 2px;
            opacity: 1;
            margin: 0 8px;
            color: black;

            &:nth-of-type(1) {
                background: #143e73;
                border: 1px solid #49f0fd;
                color: #49f0fd;
            }
        }
    }
}

.el-tooltip__popper.cell-tooltip {
    color: white;
    padding: 0;
    background: rgba(7, 17, 80, 0.75);
    background-clip: padding-box;
    border-top: 15px solid transparent;
    border-left: 15px solid transparent;
    border-right: 15px solid transparent;
    border-bottom: 15px solid transparent;
    border-image: url(../imgs/popper-mask.png) 30 stretch;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    box-shadow: none;
}

.icon-tooltip.el-tooltip__popper {
    color: white;
    padding: 0 6px;
    background: url('../imgs/icon-mask-1.png') no-repeat;
    background-size: 100% 100%;
    line-height: 39px;
    text-align: center;
    height: 39px;
    min-width: 60px;
    border-radius: 4px 4px 0 0;
}

.icon-tooltip.el-tooltip__popper[x-placement^='top'] .popper__arrow:after {
    border-top-color: rgba(7, 17, 80, 0.75);
    // border-top-width: 0;
}

.icon-tooltip.el-tooltip__popper[x-placement^='top'] .popper__arrow {
    // border-top-width: 0;
    border-top-color: #49f0fd;
}

// .icon-tooltip::before {
//     left: 50%;
//     transform: translateX(-50%);
//     width: 0;
//     height: 0;
//     position: absolute;
//     top: 38px;
//     right: -16px;
//     padding: 0;
//     border: 8px solid transparent;
//     border-top-color: rgb(7, 17, 80);
//     opacity: 0.5;
//     content: '';
//     z-index: 12;
// }

// .icon-tooltip::after {
//     left: 50%;
//     transform: translateX(-50%);
//     width: 0;
//     height: 0;
//     position: absolute;
//     top: 38px;
//     right: -17px;
//     padding: 0;
//     border: 9px solid transparent;
//     border-top-color: rgba(73, 240, 253, 1);
//     content: '';
//     z-index: 10;
// }

.el-tooltip__popper.txt-tooltip {
    color: white;
    height: 40px;
    line-height: 10px;
    padding: 0;
    background: rgba(7, 17, 80, 0.75);
    background-clip: padding-box;
    border-top: 12px solid transparent;
    border-left: 12px solid transparent;
    border-right: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-image: url(../imgs/txt-mask.png) 20 stretch;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    box-shadow: none;
}

.select-mask {
    color: white;
    padding: 3px 3px 0 3px;
    // background-clip: padding-box;
    // border-top: 12px solid transparent;
    // border-left: 19px solid transparent;
    // border-right: 19px solid transparent;
    // border-bottom: 21px solid transparent;
    background: rgba(7, 17, 80, 0.75) url(../imgs/select-mask.png) no-repeat;
    background-size: 100% 100%;
    border: 0;
    text-align: center;
    overflow: hidden;
    border-radius: 4px 4px 0 0;
    box-shadow: none;

    .el-select-dropdown__item.hover,
    .el-select-dropdown__item:hover,
    .el-cascader-node:hover {
        background: linear-gradient(270deg,
                rgba(73, 240, 253, 0) 0%,
                rgba(73, 240, 253, 0.4) 32%,
                rgba(73, 240, 253, 0.4) 66%,
                rgba(73, 240, 253, 0) 100%);
        border-radius: 0px 0px 0px 0px;
        opacity: 1;
    }

    .el-select-dropdown__item,
    .el-cascader-node {
        color: white;
        border-bottom: 1px rgba(73, 240, 253, 0.5) dashed;
    }

    .el-select-dropdown__item:last-child {
        border-bottom: 0;
    }
}
</style>
